<template lang="pug">
div.main-container
  v-layout.pa-4.pb-0(wrap row justify-center) 
    v-img.mt-4.mx-4.phone-img(:src='phoneImg' width='264' height='504')
    v-flex.ml-4.main-action-container(v-if='showSubstep1' column)
      v-container.mt-0.pt-0
        v-layout.mt-0(column align-center justify-center)
          h1.mt-0.pb-2.stepper-title Try sending yourself a text message
          p.mb-4.stepper-subtitle With a 98% open rate, people LOVE texting from LionDesk!
          v-layout.mt-4.default-text-container(column align-center justify-center) 
            p.pa-0.ma-0.default-text-msg Hi {{user.first_name}} - with LionDesk texting I can text 1 person or 500 with the click of a button.
            p.pa-0.ma-0.default-text-msg One LionDesk user sent 1 text to 1,800 and got 300 responses and 9 appointments!
      v-container.pa-0.mt-4
        v-layout.pa-0(row align-center justify-center)
          .pa-0.ma-0.mr-4(column d-inline-flex)
            p.ma-0.phone-field-caption Enter your number to receive this text from LionDesk
            v-text-field.ma-0.pa-0.phone-field-input(
              single-line
              v-model='phoneNumberInput'
              :error-messages='errorLimitMessage'
              :rules='[rules.format]'
            )
              template(slot='label')
                span.phone-field-label {{ phoneFieldLabel }}
          v-btn.ma-0.mb-1.ml-2.action-btn.primary(@click='sendMsg()' :disabled='sendBtnDisabled') Send Message
      v-container.mt-4.bottom-msg-container(column)
        p.ma-0.bottom-msg-text Don't worry, this message is not being sent to any of your contacts, this text will be sent via a LionDesk Number.
        p.ma-0.bottom-msg-text It's just showing you how easy it is to send texts with LionDesk.
    v-flex.ml-4.main-action-container(v-else column align-center justify-center)
      v-container.mt-0.pt-0
        v-layout.mt-0(column align-center justify-center)
          h1.mt-0.pb-2.stepper-title Congrats on sending your first text!
      v-container.mt-0.pt-0
        v-layout(column align-center justify-center)
          video.black(width='350' height='197' controls)
            source(:src='congratsVideo' type='video/mp4') 
      v-container.bottom-msg-container(column)
        p.ma-0.bottom-msg-text Congrats on sending your first text! Imagine sending a text like this to all your leads with a prerecorded video of yourself. Your reply rate will skyrocket!
        p.ma-0.mt-4.bottom-msg-text Did you not get the message? You can try again
          span.primary--text.font-weight-bold
            a.ml-1(@click='returnToSubstep1()') here
      v-container
        v-layout(column align-center justify-center)
          v-btn.ma-0.mb-1.ml-2.text-uppercase.action-btn.primary(@click='setStepperStage(3)') Continue
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'OnboardingStep2',
  data() {
    return {      
      phoneFieldLabel: '+1 509 425 5844',
      phoneImg: '/static/img/phone-text.svg',
      congratsVideo:
        'https://ld-marketing.s3.us-west-2.amazonaws.com/Text_simulation_video_to_add_in_app.mp4',
      showSubstep1: true,
      sendBtnDisabled: false,
      phoneNumberInput: '',
      errorLimitMessage: '',
      rules: {
        format: value => {
          const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
          return phoneRegex.test(value) || 'Please enter a valid phone number';
        },    
      },
    };
  },
  methods: {
    ...mapActions('onboarding', [
        'saveOnboardingSms',
    ]),
    ...mapMutations('onboarding', [
        'resetLimitSmsError'
    ]),
    setStepperStage(value) {
      this.$emit('click:change', value);
    },
    returnToSubstep1() {
      this.showSubstep1 = true;
    },
    handleValidationLimitSms(hasError) {
      if (hasError) {
        this.errorLimitMessage = 'Too many attempts have been done, skip to step 3';
        this.sendBtnDisabled = true;
        return;
      }
      this.errorLimitMessage = ''
      this.sendBtnDisabled = false;
    },
    async sendMsg() {
      try {
        await this.saveOnboardingSms(this.phoneNumberInput);
        this.showSubstep1 = false;
        this.phoneNumberInput = '';
        this.handleValidationLimitSms(false);
        this.resetLimitSmsError();
      } catch(error){}
    },
  },
  computed: {
    ...mapState('onboarding', ['hasLimitSmsError']),
    ...mapState('userInformation', ['user']), 
  },
  watch: {
    hasLimitSmsError(error) {
      if(error) {
        this.handleValidationLimitSms(true);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.main-container {
  height: 70vh;
}
.stepper-title {
  display: inline-block;
  font-size: 38px;
  font-weight: 500;
  line-height: 1.1;
  color: var(--v-primary-base);
}
.stepper-subtitle {
  display: inline-block;
  color: var(--v-primary-base);
}
.main-action-container {
  width: 665px;
}
.default-text-container {
  padding: 8px 16px;
  border-radius: 10px;
  border: 1px solid var(--v-background-lighten2);
}
.default-text-msg {
  font-size: 14px;
}
.phone-field-caption {
  display: inline-block;
  width: 300px;
  font-size: 12px;
}
.phone-field-input {
  width: 200px;
}
.phone-field-label {
  font-size: 16px;
  color: var(--v-text-lighten5);
}
.action-btn {
  font-size: 18px;
}
.bottom-msg-container {
  width: 550px;
  text-align: center;
}
.bottom-msg-text {
  font-size: 13px;
}
.skip-btn {
  font-size: 14px;
  margin-top: 0;
  color: var(--v-primary-lighten3);
}
.video-js {
  // width: 400px;
  height: 150px;
}
.phone-img {
  max-width: 264px;
  max-height: 504px;
}
</style>
